<template>
    <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
  
      <div class="container">
      
      <hr>
        <div class="row">
          <div class="col-md-4">
              <h3>Información General
              </h3>
            <table>
              <tr>
                <td>Nombre</td>
                <td>{{datos.razon_social}}</td>
              </tr>
              <tr>
                <td>RFC</td>
                <td></td>
              </tr>
              <tr>
                <td>Nombre del representante:</td>
                <td>{{datos.nombre_representante}}</td>
              </tr>
              <tr>
                <td>Correo del representante:</td>
                <td>{{datos.email}}</td>
              </tr>
              <tr>
                <td>Tipo:</td>
                <td>{{datos.tipo}}</td>
              </tr>
              <tr>
                <td>Domicilio:</td>
                <td>{{datos.domicilio}}</td>
              </tr>
              <tr>
                <td>Capacidad:</td>
                <td>{{datos.capacidad}}</td>
              </tr>
              <tr>
                <td>Voltaje de conexión:</td>
                <td>{{datos.voltaje_conexion}}</td>
              </tr>
              <tr>
                <td>CIE:</td>
                <td></td>
              </tr>
              <tr>
                <td>Asignado:</td>
                <td>{{datos.usuario}}</td>
              </tr>
              <tr>
                <td>Creador:</td>
                <td>{{datos.usuario}}</td>
              </tr>
            </table><br>
            <div class="d-flex align-items-center">
              <button type="button" class="btn btn-dark" @click="generatePDF">
                <i class="mdi mdi-file-pdf mr-2"></i> <!-- Añadir margen a la derecha -->
                Contrato Persona Fisica
              </button> &nbsp;
              
              <button type="button" class="btn btn-dark ml-2" @click="generatePDFPersonaMoral">
                  <i class="mdi mdi-file-pdf mr-2"></i> <!-- Añadir margen a la derecha -->
                  Contrato Persona Moral
              </button>
          </div>
          </div>
          <div class="col-md-4">
              <h3>Presupuesto</h3>
            <table>
              
              <tr>
                <td>Importe</td>
                <td>$ {{datos.importe}}</td>
              </tr>
              <tr>
                <td>Rango de Horas</td>
                <td></td>
              </tr>
              <tr>
                <td>CIE:</td>
                <td></td>
              </tr>
              
            </table>
            <!--<h3>Enviar contrato</h3>--> 
           
            
          </div>
          <!--<div class="col-md-4">
            <h3>Solicitud de Inspección</h3> 
  
            <button type="button" class="btn btn btn-dark" v-if="datos.solicitud_inspeccion == 0 ||
             datos.solicitud_inspeccion == null " @click="enviarSolicitud()">
                <i class="mdi mdi-pen"></i><router-link to="/solicitudinspeccion">Enviar Solicitd </router-link> 
             
            </button>
            <button type="button" class="btn btn btn-dark" v-else>
              <i class="mdi mdi-pen"></i><router-link to="/solicitudinspeccion">Ver Solicitd </router-link> 
           
            </button>
  
          </div>-->
        </div>
        <br>
        <!--<div class="col-md-12" style="text-align: left !important;">
          <button type="button" class="btn btn btn-dark" >
              <i class="mdi mdi-pen"></i>
              <router-link  to="/editarcotizacion" style="color: white;"><span>Editar</span></router-link>
          </button> &nbsp;
          <button type="button" class="btn btn btn-dark" >
            <i class="mdi mdi-checkbox-multiple-blank"></i>
            <router-link  to="/cotizacion" style="color: white;"><span>Cotizaciones</span></router-link>
          </button>&nbsp;
          <button type="button" class="btn btn btn-dark"  @click="generatePDF">
            <i class="mdi mdi-file-pdf"></i>
           <span>Pdf</span>
          </button>
        </div>-->
  
      </div>
    </template>
    
    <script>
    import axios from 'axios';
    import Swal from 'sweetalert2';
    
    export default {
      data() {
        return {
          isLoading:false,
          datos: [],
          nombreOficio:''
        }
      },
      created() {
        this.fetchData();
      },
      methods: {
        enviarSolicitud(){
          var id = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer+'solicitudInspeccion', { id: id })
            .then(response => {
              if (response.status == 200) {
                Swal.fire('Exito!', 'Se genero con exito la solicitud', 'success');
               
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
  
        },
        downloadPDF() {
          // URL del archivo PDF en el servidor
          const pdfUrl = 'https://api.seigrupo.com.mx/'+this.datos.oficio_cfe;
          // Crear un enlace invisible para desencadenar la descarga
         /* const link = document.createElement('a');
          link.href = pdfUrl;
          link.setAttribute('download', this.nombreOficio); // Nombre del archivo a descargar
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);*/
   // Abrir el PDF en una nueva pestaña
   window.open(pdfUrl, '_blank');
  
          
        },
         generatePDF() {
          var idcotizacion = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer + 'generatePdfContrato', {idcotizacion:idcotizacion}, {
    responseType: 'blob'
})
.then(response => {
    if (response.status === 200) {
        // Crear un objeto Blob a partir de la respuesta
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'contrato.pdf'); // Nombre del archivo

        // Agregar y hacer clic en el enlace para iniciar la descarga
        document.body.appendChild(link);
        link.click();

        // Limpiar
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // Liberar la memoria utilizada por el objeto URL
    }
})
.catch(error => {
    Swal.fire('¡Error!', 'Ocurrió un error', 'error');
});
           /* fetch('http://127.0.0.1:8000/api/generatePdfContrato', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }})
                .then(response => response.json())
                .then(data => {
                    const url = data.url;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'contrato.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch(error => console.error('Error al descargar el PDF:', error));*/
      },
      generatePDFPersonaMoral() {
          var idcotizacion = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer + 'generatePdfContratoPersonaMoral', {idcotizacion:idcotizacion}, {
            responseType: 'blob'
          })
          .then(response => {
              if (response.status === 200) {
                  // Crear un objeto Blob a partir de la respuesta
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', 'contratopersonamoral.pdf'); // Nombre del archivo

                  // Agregar y hacer clic en el enlace para iniciar la descarga
                  document.body.appendChild(link);
                  link.click();

                  // Limpiar
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url); // Liberar la memoria utilizada por el objeto URL
              }
          })
          .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
        },
          regresar(){

          this.$router.push('/cotizacion');
          },
        fetchData() {
          this.isLoading = true;
          var id = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer+'datosCotizacion', { id: id })
            .then(response => {
              if (response.status == 200) {
                this.isLoading = false;
                this.datos = response.data.data[0];
              
                if(this.datos.oficio_cfe){
                  var arreglo = this.datos.oficio_cfe.split('/');
                  this.nombreOficio = arreglo[2];
                }
                
                
                console.log(this.datos);
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
        }
      }
    }
    </script>
    
    <style scoped>
    table {
      border-collapse: collapse;
      width: 100%;
    }
    
    table, th, td {
      border: 1px solid black;
    }
    
    th, td {
      padding: 8px;
      text-align: left;
    }
    </style>
    